import { render, staticRenderFns } from "./welder.vue?vue&type=template&id=84a91e9c&"
import script from "./welder.vue?vue&type=script&lang=js&"
export * from "./welder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports